export const FETCH_TAGS = 'tag/FETCH';
export const FETCH_TAGS_SUCCESS = 'tag/FETCH_SUCCESS';
export const FETCH_TAGS_FAIL = 'tag/FETCH_FAIL';

/* eslint-disable */
const TagReducer = (state = {
}, action = {}) => {
  switch (action.type) {
    case FETCH_TAGS:
      return {
        ...state,
        [action.sku]: {
          ...(state[action.sku] || {}),
          isLoading: true,
        },
      };
    case FETCH_TAGS_SUCCESS:
      const newState = { ...state };
      action.payload.data.forEach((skuData) => {
        newState[skuData.sku] = {
          data: skuData.data,
          sku: skuData.sku,
        };
      });
      return newState;
    case FETCH_TAGS_FAIL:
      return {
        ...state,
        [action.sku]: {
          data: [],
          sku: action.sku,
          isLoading: false,
          isAvailable: false,
          isPriceUpdated: true,
        },
      };
    default:
      return { ...state };
  }
};

export default TagReducer;
